export default __webpack_public_path__ + "static/media/image_1.df40ffba.jpg";